import { GET, PATCH, POST } from "../../helper/xbi4RestFunctions";

export const getReportsToEmail = async (org_id: any, org_user_id: any) => {
  const path = `/orgs/${org_id}/users/${org_user_id}/reports_to_email`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
